import ReactParticles from 'react-particles-js'

import { particlesConfig } from '~helpers/particles-config'

const Particles = () => (
  <ReactParticles
    params={particlesConfig}
    css={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      zIndex: 1,
    }}
  />
)

export default Particles
